// src/config.js

const config = {
    // apiEndpoint: process.env.REACT_APP_API_URL || "http://localhost:5000"
    apiEndpoint: process.env.REACT_APP_API_URL || "https://673a512c339a4ce44517db5f.mockapi.io"
  };
  
  export default config;
  